<template>
<div>  
    <b-table 
        striped 
        hover 
        selectable 
        select-mode="single" 
        @row-selected="onRowSelected" 
        :items="items" 
        :fields="fields" 
        :filter="filter"
        @filtered="onFiltered"
        :per-page="perPage"
        :current-page="currentPage">
    </b-table>
    
    <TablePagination 
      :total-rows="totalRows" 
      :per-page="perPage" 
      @pageChange="onPageChange">
    </TablePagination>
  
</div>    
</template>

<script>

import TablePagination from '@/components/Misc/TablePagination'
import timetable from '@/store/timetable/timetable'

export default {
    name: 'organisationListTable',
    components: { TablePagination },
    props: ['filter'],
    data: function() {
        return {
            perPage: 10,
            currentPage: 1,
            filteredRows: 0,
            fields: [
                { key:"organisation.id" , label: this.$t('organisation.id'), sortable: true },
                { key:"organisation.name" , label: this.$t('organisation.name'), sortable: true }
                ],
        }
    },
    computed: {
        items () { 
            return this.$store.state.timetable.organisations.data;
        },
        totalRows() {
            return this.filteredRows ? this.filteredRows : (this.items ? this.items.length : 0);
        }               
    },
    created() {
        if (!this.$store.state.timetable) {
            this.$store.registerModule("timetable" , timetable);
        }
        this.$store.dispatch('timetable/getOrganisations');       
    },
    methods: {
        onRowSelected (items) {
            this.$emit('selectItem', items[0]);        
        },
        onFiltered(filteredItems) {
            this.filteredRows = filteredItems.length;
            this.currentPage = 1;
        },
        onPageChange(page){
            this.currentPage = page;
        }
    }
}

</script>